import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    title_fi_FI: "",
    title_sv_SE: "",
    title_en_US: "",
    startDate: null,
    address: "",
    longitude: "",
    latitude: "",
    shortDescription_fi_FI: "",
    shortDescription_sv_SE: "",
    shortDescription_en_US: "",
    innovation_fi_FI: "",
    innovation_sv_SE: "",
    innovation_en_US: "",
    backgroundInformation_fi_FI: "",
    backgroundInformation_sv_SE: "",
    backgroundInformation_en_US: "",
    operations: [],
    commitmentCategoryId: "",
    commitmentSubcategoryId: "",
    organizationName: "",
    createdByUserId: "",
    status: "",
    commitmentType: "",
    categoryIds: [],
    endDate: null,
    id: "",
    version: 1.0,
    allowToSelectPublicity: false,
    reportingInterval: ""

}

const commitmentSlice = createSlice({
    name: "commitment",
    initialState,
    reducers: {
        resetCommitment: ( ) => {
            return initialState;
        },
        changeCommitmentTitle: (state, action) => {
            state[`title_${action.payload.language}`] = action.payload.title
        },
        changeAddress: (state, action) => {
            state.address = action.payload.address
            state.latitude = action.payload.latitude
            state.longitude = action.payload.longitude
        },
        changeStartDate: (state, action) => {
            state.startDate = action.payload
        },
        changeEndDate: (state, action ) => {
            state.endDate = action.payload
        },
        changeShortDescription: (state, action ) => {
            state[`shortDescription_${action.payload.language}`] = action.payload.content
        },
        changeCategoryId: (state, action) => {
            state.commitmentCategoryId = action.payload;
        },
        changeSubcategoryId: (state, action ) => {
            state.commitmentSubcategoryId = action.payload;
        },
        changeCommitmentId: (state, action ) => {
            state.id = action.payload
        },
        changeCreatedByUserId: (state, action ) => {
            state.createdByUserId = action.payload
        },
        changeCommitmentType: ( state, action ) => {
            state.commitmentType = action.payload
        },
        changeOrganizationName: ( state, action ) => {
            state.organizationName = action.payload
        },
        changeStatus: ( state, action ) => {
            state.status = action.payload
        },
        changePublicitySelection: ( state, action ) => {
            state.allowToSelectPublicity = action.payload
        },
        setCategoryIds: ( state, action ) => {
            state.categoryIds = action.payload
        },
        setOperations: ( state, action ) => {
            state.operations = action.payload
        },
        addOperation: ( state, action ) => {
            state.operations.push(action.payload)
        },
        deleteOperation: ( state, action ) => {
            state.operations = state.operations.filter(mappedOperation => mappedOperation.operationId !== action.payload.operationId)
        },
        changeOperationTitle: ( state, action ) => {
            state.operations = state.operations
                .map(mappedOperation => mappedOperation.operationId === action.payload.operationId
                    ? {...mappedOperation, [`operationTitle_${action.payload.language}`]: action.payload.title }
                    : mappedOperation)
        },
        changeOperationTheme: (state, action) => {
            state.operations = state.operations
                .map(mappedOperation => mappedOperation.operationId === action.payload.operationId
                    ? {...mappedOperation, operationTheme: action.payload.operationTheme}
                    : mappedOperation
                )
        },
        changeOperationDescription: (state, action ) => {
            state.operations = state.operations
                .map(mappedOperation => mappedOperation.operationId === action.payload.operationId
                    ? {...mappedOperation, [`operationDescription_${action.payload.language}`]: action.payload.content }
                    : mappedOperation)
        },
        changeOperationPrivacy: (state, action ) => {
            state.operations = state.operations
                .map(mappedOperation => mappedOperation.operationId === action.payload.operation.operationId
                    ? {...mappedOperation, privateOperation: action.payload.privacy }
                    : mappedOperation)
        },
        addMeter: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters.push(action.payload.meter)
        },
        deleteMeter: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters = state.operations[index].meters.filter(mappedMeter => mappedMeter.meterId !== action.payload.meterId)
        },
        resetMeter: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters = state.operations[index].meters
                .map(mappedMeter => mappedMeter.meterId === action.payload.meterId
                ? {
                    ...mappedMeter,
                    meterType_fi_FI: "",
                    meterType_en_US: "",
                    meterType_sv_SE: "",
                    meterValueType: "",
                    startingLevel: "",
                    targetLevel: "",
                    graphType: ""
                }
                : mappedMeter )
        },
        changeMeterTitle: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters = state.operations[index].meters
                .map(mappedMeter => mappedMeter.meterId === action.payload.meterId
                    ? {...mappedMeter, [`meterType_${action.payload.language}`]: action.payload.meterTitle}
                    : mappedMeter )
        },
        changeMeterValueType: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters = state.operations[index].meters
                .map(mappedMeter => mappedMeter.meterId === action.payload.meterId
                    ? {...mappedMeter, meterValueType: action.payload.meterValueType}
                    : mappedMeter )
        },
        changeMeterChartType: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters = state.operations[index].meters
                .map(mappedMeter => mappedMeter.meterId === action.payload.meterId
                    ? {...mappedMeter, meterChartType: action.payload.meterChartType}
                    : mappedMeter )
        },
        changeMeterStartingLevel: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters = state.operations[index].meters
                .map(mappedMeter => mappedMeter.meterId === action.payload.meterId
                    ? {...mappedMeter, startingLevel: action.payload.startingLevel}
                    : mappedMeter )

        },
        changeMeterTargetLevel: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters = state.operations[index].meters
                .map(mappedMeter => mappedMeter.meterId === action.payload.meterId
                    ? {...mappedMeter, targetLevel: action.payload.targetLevel}
                    : mappedMeter )
        },
        setMeter: ( state, action ) => {
            const index = state.operations.findIndex(mappedOperation => mappedOperation.operationId === action.payload.operationId)
            state.operations[index].meters = state.operations[index].meters
                .map(mappedMeter => mappedMeter.meterId === action.payload.meterId
                    ? action.payload.preDefinedMeter
                    : mappedMeter )
        },
        changeWhatsNew: ( state, action ) => {
            state[`innovation_${action.payload.language}`] =  action.payload.content
        },
        changeBackgroundInfo: ( state, action ) => {
            state[`backgroundInformation_${action.payload.language}`] = action.payload.content
        },
        setCommitment: ( state, action ) => {
            return {...state, ...action.payload}
        },
        changeReportingInterval: (state, action) => {
            state.reportingInterval = action.payload.interval
        },
        changeReportReminder: (state, action) => {
            state.reportReminder = action.payload.reminders;
        }

    }

})

export const {
    resetCommitment,
    changeCommitmentTitle,
    changeAddress,
    changeStartDate,
    changeEndDate,
    changeShortDescription,
    changeCategoryId,
    changeSubcategoryId,
    changeCommitmentId,
    changeCreatedByUserId,
    changeCommitmentType,
    changeOrganizationName,
    changeStatus,
    changePublicitySelection,
    setCategoryIds,
    setOperations,
    addOperation,
    changeOperationTitle,
    changeOperationTheme,
    changeOperationDescription,
    changeOperationPrivacy,
    deleteOperation,
    addMeter,
    deleteMeter,
    resetMeter,
    changeMeterTitle,
    changeMeterValueType,
    changeMeterChartType,
    changeMeterStartingLevel,
    changeMeterTargetLevel,
    setMeter,
    changeWhatsNew,
    changeBackgroundInfo,
    setCommitment,
} = commitmentSlice.actions;

export default commitmentSlice;


// WEBPACK FOOTER //
// ./src/state/slices/commitmentSlice.js